export const scrollToClass = () => {
    const identifier = "#scroll-to-class:";
    const links = document.querySelectorAll<HTMLAnchorElement>(`a[href^="${identifier}"]`);

    links.forEach(link => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            
            const hrefAttr = link.getAttribute('href');
            if (!hrefAttr) return;
            
            const targetClass = hrefAttr.split(identifier)[1];
            if (!targetClass) return;
            
            const targetElement = document.querySelector(`.${targetClass}`);
            
            if (targetElement) {
                const isDesktop = window.innerWidth >= 1300; 
                const headerOffset = isDesktop ? 90 : 60; 
                
                const elementPosition = targetElement.getBoundingClientRect().top;
                const offsetPosition = elementPosition + window.scrollY - headerOffset;
                
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        });
    });
}